import { alkymetricsClient } from '../alkymetricsClient';

export const getActivePartnerNews = async (limit = 10) => {
  try {
    const { data } = await alkymetricsClient.get('/partners-news', {
      params: { limit },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const incrementNewsView = async (newsId) => {
  try {
    await alkymetricsClient.post(`/partners-news/${newsId}/view`);
  } catch (error) {
    // Don't throw, this is fire-and-forget
  }
};
